import { connect } from 'react-redux'

import AccountDetails from './AccountDetails'
import * as actions from '../../redux/organisations'
import { getGlobalCommissionRates } from '../../redux/configurations';
import { setDisplayMenu } from '../../redux/options/actions';

const mapStateToProps = (state) => ({
  orgID: state.authentication.orgID,
  mainTabValue: state.organisations.mainTabValue,
  branches: state.organisations.branches,
  message: state.organisations.message,
  whiteLabelApps: state.organisations.whiteLabelApps,
  globalCommissionRates: state.configurations.globalCommissionRates,
  userRole: state.authentication.userRole,
});

const actionCreators = {
  ...actions,
  getGlobalCommissionRates,
  setDisplayMenu
};

export default connect(mapStateToProps, actionCreators)(AccountDetails)
